module.exports = __webpack_public_path__ + "statics/img/bubble-ios-1edd791b.png";


//////////////////
// WEBPACK FOOTER
// ./web/img/xhpopulrz/download/bubble-ios.png
// module id = 1218
// module chunks = 143